import React from 'react';
import styled from 'styled-components';

import { Skeleton, SkeletonAvatar } from '~/atomic/atom/Skeleton';

import { MethodPaymentTemplate } from './MethodPaymentTemplate';

export const MethodPaymentSkeleton = () => {
  return (
    <MethodPaymentTemplate
      Logo={(
        <SkeletonAvatar
          size={40}
          active
        />
      )}
      Text={(
        <SCTextSkeleton
          active
          paragraph={{ rows: 0 }}
        />
      )}
      isDisabled
    />
  );
};

const SCTextSkeleton = styled(Skeleton)` && {
    .ant-skeleton-title {
      width: 100% !important;
    }
  }
`;
